<template>
  <div id="app">
    <router-view></router-view>
    <loading ref="loading"></loading>
    <warnBox ref="warn_box"></warnBox>

    <!-- <div class="upgrade-mask">
      <div class="upgrade-box">
        <div class="upgrade-text">
          为提供更好的学习服务，平台现进行维护更新，对此给您造成的不便，敬请谅解。
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import warnBox from "./components/common/warn";
import loading from "./components/common/loading";
import axios from "axios";
import config from "@/api/base.js";
export default {
  name: "app",
  components: {
    warnBox,
    loading,
  },
  created() {
    this.isWx();
    this.getData();
  },
  methods: {
    getData() {
      if (!sessionStorage.getItem("uuid")) {
        axios.post("/getUuid.html", {}, config).then(function (res) {
          sessionStorage.setItem("uuid", res.data.uuid);
        });
      }
    },
    isWx() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        sessionStorage.setItem("isWx", "true");
      } else {
        sessionStorage.setItem("isWx", "false");
      }
    },
  },
};
</script>
<style scoped>
/* 全屏遮罩 + 背景虚化 */
.upgrade-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.25);
  /* 背景虚化毛玻璃 */
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

/* 弹框容器 */
.upgrade-box {
  width: 90%;
  padding: 20px;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.15);
}

/* 文字样式 */
.upgrade-text {
  font-size: 18px;
  color: #333;
  text-align: center;
  letter-spacing: 2px;
}
</style>



// WEBPACK FOOTER //
// App.vue?143def56